import {take, put} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as sadehActionTypes from '../sadehActionTypes';

/**
 * Update SADEH service provider flow
 */
const updateSADEHServiceProviderFlow = function* updateSADEHServiceProviderFlow() {
    while (true) {
        const {payload} = yield take(sadehActionTypes.SUBMIT_SADEH_SERVICE_PROVIDER_FORM);
        const {serviceAssignmentLineNo, serviceAssignmentData, serviceCaseId} = payload;

        yield* updateServiceAssignment({
            caller: sadehActionTypes.SUBMIT_SADEH_SERVICE_PROVIDER_FORM,
            assignmentType: efServiceAssignmentTypes.DEATH,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: sadehActionTypes.SUBMIT_SADEH_SERVICE_PROVIDER_FORM},
        });
    }
};

export default updateSADEHServiceProviderFlow;
